import { IUser } from './user.model';

export enum ProfileEndpoints {
  ROOT = '/profile',
}

export const staticProfileEndpoints = {
  GET_PROFILE: ProfileEndpoints.ROOT,
  UPDATE_PROFILE: ProfileEndpoints.ROOT,
};

// ============== DTO ==============

export type IUpdateProfileDTO = Partial<IUser>;

// ============== Response ==============

export type IProfileResponse = IUser;
